import { ColumnViewModel } from '../../shared/column-types';

export const DISEASES_GDA_SUMMARY: ColumnViewModel = {
  columns: [
    'evidenceTimeline',
    'diseaseName',
    'numGenesAssociatedToDisease',
    'numVariantsAssociatedToDisease',
    'diseaseUMLSCUI',
    'geneSymbol',
    'geneNcbiID',
    'geneDescription',
    'score',
    'sourceScore',
    'numPMIDsupportingAssociation',
    'numCTs',
    'numberChemsIncludedInEvidence',
    'numberPmidsWithChemsIncludedInEvidence',
    'numDBSNPsupportingAssociation',
    'yearInitial',
    'yearFinal',
    'EI',
    'EL',
    'diseaseType',
    'diseaseClassName_MSH',
    'diseaseClassName_UMLS',
    'diseaseClassName_DO',
    'diseaseClassName_HPO',
    'prevalence',
    'disease_inheritance',
    'chemPrefName',
    'chemID',
    'diseaseCode_DO',
    'diseaseCode_MSH',
    'diseaseCode_HPO',
    'diseaseCode_ICD10',
    'diseaseCode_ICD9CM',
    'diseaseCode_NCI',
    'diseaseCode_OMIM',
    'diseaseCode_ORDO',
    'diseaseCode_MONDO',
    'diseaseCode_EFO',
    'numDiseasesAssociatedToGene',
    'numVariantsAssociatedToGene',
    'geneDSI',
    'geneDPI',
    'genepLI',
    'geneEnsemblIDs',
    'geneProteinStrIDs',
    'geneProteinClassNames',
    'geneNcbiType',
    'pathwayName',
    'pathwayID',
  ],
  defaultVisible: [
    'evidenceTimeline',
    'diseaseName',
    'geneSymbol',
    'geneDescription',
    'score',
    'sourceScore',
    'numPMIDsupportingAssociation',
    'numCTs',
    'numberChemsIncludedInEvidence',
    'numberPmidsWithChemsIncludedInEvidence',
    'numDBSNPsupportingAssociation',
    'yearInitial',
    'yearFinal',
    'EI',
    'numDiseasesAssociatedToGene',
    'numVariantsAssociatedToGene',
    'geneDSI',
    'geneDPI',
    'genepLI',
  ],
};
